module.exports = __webpack_public_path__ + "static/media/icons8-telegram.a8a26882.svg";